import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { variantMap, Heading } from '@grandvisionhq/elements';
import { parseHtml, domToReact } from '@grandvisionhq/utils';
import { colorHexMap } from '../Util/color-map.js';

const regHex = /#([a-f0-9]{3}){1,2}\b/i;
const regPresetBg = /black|grey|white/;
const alignmentOpts = [
    'left',
    'right',
    'center'
];
const variantReverseMap = Object.entries(variantMap).reduce((acc, [key, value])=>swcHelpers.objectSpread({}, acc, {
        [value]: key
    })
, {});
const isElement = (domNode)=>'attribs' in domNode
;
const isAlignment = (alignment)=>alignmentOpts.includes(alignment)
;
const getOptions = (textColor)=>{
    let rowIndex = 0;
    //TODO: With React18, we need to use here the useId() hook to create a unique id per table,
    // so we can support more than one per page
    // Example: `${idFromTheReactHook}_${rowIndex}_${columnIndex}`
    return {
        replace: (domNode)=>{
            if (isElement(domNode) && domNode.name in variantReverseMap) {
                var ref;
                let align = 'left';
                if ((ref = domNode.attribs.style) === null || ref === void 0 ? void 0 : ref.includes('text-align')) {
                    const styles = domNode.attribs.style.split(';');
                    const textAlign = styles.find((s)=>s.includes('text-align')
                    );
                    const [_, value] = textAlign ? textAlign.split(':') : [];
                    align = value && isAlignment(value) ? value : 'left';
                }
                return /*#__PURE__*/ React.createElement(Heading, {
                    variant: variantReverseMap[domNode.name],
                    align: align,
                    color: textColor === 'white' ? 'alt' : undefined
                }, domToReact(domNode.children)); //
            // This block of code handles the creation of accessibility attributes for a table created using RichText
            } else if (isElement(domNode) && domNode.name === 'tr') {
                const childElements = Array.from(domNode.children).filter(isElement);
                const rowWithHeaders = childElements.find((element)=>element.name === 'th'
                );
                const isHeaderRow = rowWithHeaders !== undefined;
                // Iterate through each child element (table cells) within the current row
                domNode.children.forEach((child, columnIndex)=>{
                    if (isElement(child)) {
                        if (child.name === 'th') {
                            var ref;
                            const previousElement = (ref = child.prev) === null || ref === void 0 ? void 0 : ref.prev;
                            if (parseInt(child.attribs.rowspan) > 1) {
                                // If the <th> element spans multiple rows, set the 'scope' attribute.
                                child.attribs.scope = 'rowgroup';
                            } else if (previousElement && isElement(previousElement) && previousElement.attribs.id) {
                                // If the <th> element doesn't span rows, associate it with the previous element's 'id'.
                                child.attribs.headers = previousElement.attribs.headers || previousElement.attribs.id;
                            }
                            // Assign a unique 'id' to the <th> element for reference
                            child.attribs.id = `${rowIndex}_${columnIndex}`;
                        } else if (!isHeaderRow && child.name === 'td') {
                            // For data cells (<td>), calculate the 'headers' attribute to associate them with header cells
                            // Calculate the 'headers' attribute for data cells
                            // 'rowIndex - 1' is used to reference the previous row
                            // 'columnIndex + 2' accounts for the presence of <th> elements in the current row
                            child.attribs.headers = `${rowIndex - 1}_${columnIndex + 2}`;
                        }
                    }
                });
                // Increment the rowIndex to keep track of table row index
                rowIndex++;
            }
            return domNode;
        }
    };
};
const RichTextArea = ({ content , className , textColor ='black' , backgroundColor ='transparent' , fullWidth  })=>{
    const classNames = classnames('rich-text-area', `rich-text-area--text-${textColor}`, {
        'rich-text-area--full-width': fullWidth
    }, className);
    const richTextAreaStyle = {
        backgroundColor: regHex.test(backgroundColor) ? backgroundColor : regPresetBg.test(backgroundColor) ? colorHexMap[backgroundColor] : 'transparent'
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: classNames,
        style: richTextAreaStyle
    }, parseHtml(content, getOptions(textColor)));
};
var RichTextArea$1 = RichTextArea;

export { RichTextArea, RichTextArea$1 as default };
//# sourceMappingURL=RichTextArea.js.map
